import React from 'react';

export default function PoliticaPrivacidad() {
  return (
    <main className="site-width pagina-politica">
      <h2>Política de Privacidad</h2>

      <p>Al acceder, navegar y utilizar esta página web y su sistema de reservas, aceptas esta Política de Privacidad, así como nuestras condiciones del sistema de citas y la política del servicio. Si no estás de acuerdo con alguno de estos documentos, te recomendamos no utilizar esta plataforma.</p>


      <h3>1. Responsable del Tratamiento</h3>
      <p>El responsable del tratamiento de los datos personales es <strong>Barber Mujica</strong>, quien se compromete a tratarlos conforme a la normativa vigente en protección de datos personales.</p>

      <h3>2. Datos que Recogemos</h3>
      <p>A través de nuestro sistema de reservas online, recogemos los siguientes datos:</p>
      <ul>
        <li><strong>Nombre y apellidos:</strong> necesarios para identificar tu reserva.</li>
        <li><strong>Teléfono:</strong> imprescindible para gestionar tu cuenta y tus citas.</li>
        <li><strong>Email (opcional):</strong> solo lo usamos para notificarte confirmaciones, cambios o cancelaciones de citas.</li>
        <li><strong>Historial de citas:</strong> almacenamos las reservas pasadas y futuras asociadas a tu cuenta.</li>
      </ul>

      <h3>3. Finalidad del Tratamiento</h3>
      <p>Los datos que recopilamos se utilizan con los siguientes fines:</p>
      <ul>
        <li>Gestionar el sistema de reservas online.</li>
        <li>Crear automáticamente una cuenta de usuario vinculada a tu número de teléfono.</li>
        <li>Notificarte por email (si lo proporcionas) sobre cualquier cambio en tus reservas.</li>
        <li>Aplicar nuestras políticas si se incumplen las condiciones (como faltas reiteradas).</li>
      </ul>

      <h3>4. Base Legal del Tratamiento</h3>
      <p>La base legal del tratamiento es:</p>
      <ul>
        <li><strong>El consentimiento del usuario,</strong> al aceptar nuestras condiciones y política del sistema de citas.</li>
        <li><strong>La ejecución del contrato,</strong> al ofrecerte el servicio de gestión de reservas.</li>
      </ul>

      <h3>5. Conservación de los Datos</h3>
      <p>Tus datos se conservarán mientras tu cuenta esté activa y mientras exista una relación con nuestro sistema de reservas. Puedes solicitar su supresión en cualquier momento, salvo que exista obligación legal de conservarlos.</p>

      <h3>6. Comunicación de Datos</h3>
      <p>No compartimos tus datos con terceros salvo requerimiento legal. No realizamos transferencias internacionales ni enviamos comunicaciones publicitarias.</p>

      <h3>7. Seguridad</h3>
      <p>Tus datos están protegidos mediante medidas técnicas y organizativas adecuadas, y almacenados en servidores seguros para evitar accesos no autorizados o pérdidas.</p>

      <h3>8. Derechos del Usuario</h3>
      <p>Como usuario puedes ejercer los siguientes derechos:</p>
      <ul>
        <li>Acceso a tus datos personales.</li>
        <li>Rectificación de los datos inexactos.</li>
        <li>Supresión cuando ya no sean necesarios.</li>
        <li>Oposición o limitación al tratamiento.</li>
        <li>Portabilidad de los datos.</li>
      </ul>
      <p>Para ejercer estos derechos puedes escribirnos desde la plataforma o contactar por WhatsApp. Te responderemos en un plazo máximo de 30 días.</p>

      <h3>9. Modificaciones</h3>
      <p>Barber Mujica se reserva el derecho de modificar esta política cuando lo considere necesario. Los cambios serán publicados en esta misma página o notificados a través de los medios disponibles.</p>

      <p><strong>Gracias por confiar en Barber Mujica.</strong> Tu privacidad es tan importante como tu cita.</p>
    </main>
  );
}
